import { useSelector, useDispatch } from 'react-redux'
import { useEffect, useState } from 'react'
import { retrieve } from 'store/attendance/attendance-report'
import Attendance from 'components/Attendance'
import NotFound from 'components/NotFound'
import { useBasePath, useSession } from 'components/Providers'
import { Box, LinearProgress, Paper } from '@mui/material'
import MarkingPeriodField from 'components/MarkingPeriodField'
import Skeleton from '../../../Member/Attendance/Skeleton'
import { getMarkingPeriods } from 'store/lookup'

export default function Index() {
  const dispatch = useDispatch()
  const basePath = useBasePath()
  const [notFound, setNotFound] = useState(false)
  const { person: { type }, academicYear } = useSession()
  const session = useSelector(state => state.session)
  const personMemberId = session.id
  const parentStudentId = useSelector(state => state.session.studentMemberId);
  const { currentMarkingPeriodId } = useSelector(state => state.lookup);
  // const parentStudent = useSelector(state => state.academic?.parentStudent?.selectedStudent);

  useEffect(() => {
    if (!currentMarkingPeriodId) {
      dispatch(getMarkingPeriods({ id: academicYear?.id }));
    }
  }, [dispatch, academicYear]);

  useEffect(() => {
    const personType = type === 'parent' ? 'student' : type;
    const memberId = type === 'parent' ? parentStudentId : personMemberId;

    if (!currentMarkingPeriodId || !memberId || !personType) return

    dispatch(retrieve({ memberId, type: personType, markingPeriodId: currentMarkingPeriodId })).then(res => {
      res.error && setNotFound(true)
    })
  }, [dispatch, type, personMemberId, parentStudentId, currentMarkingPeriodId])
  const attendanceReports = useSelector(state => state.attendance.attendanceReport.list)

  let absenceRate =
    (attendanceReports?.daily?.absent * 100) /
    (attendanceReports?.daily?.absent + attendanceReports?.daily?.tardy + attendanceReports?.daily?.present)

  absenceRate = isNaN(absenceRate) || !isFinite(absenceRate) ? '-' : absenceRate

  if (!personMemberId || (type === 'parent' && !parentStudentId)) return <LinearProgress color="primary" />

  if (notFound) return <NotFound basePath={`${basePath}`} />
  
  return (
    <Box component={Paper} sx={{ py: 2 }}>
      <MarkingPeriodField
        label='Marking Period'
        academicYearId={academicYear?.id}
        includeAll={true}
        width="50%"
        size={"small"}
      />
      {!attendanceReports || !currentMarkingPeriodId ? (
        <Skeleton />
      ) : (
        <Attendance absenceRate={absenceRate} attendanceReports={attendanceReports} />
      )}
    </Box>
  )
}